import React from "react";

/**
 * Text-based CNL Tech logo.
 * - Square mark with "CNL" monogram in dark blue.
 * - Wordmark "CNL Tech" in Outfit weight 700.
 */
export default function Logo({ variant = "dark", className = "" }) {
  const isInverse = variant === "inverse";
  const markBg = isInverse ? "#FFFFFF" : "#0B192C";
  const markText = isInverse ? "#0B192C" : "#FFFFFF";
  const wordColor = isInverse ? "#FFFFFF" : "#0B192C";
  const subColor = isInverse ? "#9CA3AF" : "#4B5563";

  return (
    <div
      className={`flex items-center gap-2.5 ${className}`}
      data-testid="cnl-logo"
    >
      <div
        className="flex h-9 w-9 items-center justify-center rounded-sm"
        style={{
          backgroundColor: markBg,
          border: isInverse ? "1px solid #1E3E62" : "none",
        }}
      >
        <span
          className="font-bold text-[13px] tracking-[0.02em]"
          style={{
            color: markText,
            fontFamily: "Outfit, sans-serif",
          }}
        >
          CNL
        </span>
      </div>
      <div className="flex flex-col leading-none">
        <span
          className="font-bold text-[18px] tracking-tight"
          style={{ color: wordColor, fontFamily: "Outfit, sans-serif" }}
        >
          CNL Tech
        </span>
        <span
          className="text-[10px] font-medium uppercase tracking-[0.18em] mt-0.5"
          style={{ color: subColor, fontFamily: "IBM Plex Sans, sans-serif" }}
        >
          Electronics Reseller
        </span>
      </div>
    </div>
  );
}
